const CategoryConstants = {
    HEALTH: 'Health',
    BUSINESS: 'Business',
    SPORT: 'Sport',
    INSPIRATION: 'Inspiration',
}

export default CategoryConstants
